<div class="container px-8">
    <app-title title="Edit User"></app-title>

    <div class="border-solid border-gray-200 border rounded-3xl px-16 py-8 ">
        <h3 class="text-primary poppins-medium mb-12">User Information</h3>
        <form [formGroup]="editUserForm">
            <section class="grid grid-cols-2 gap-8">
                <section class="flex flex-col gap-2">
                    <label for="firstName">First Name
                        <span style="color: red;">*</span>
                    </label>
                    <input pInputText formControlName="firstName" [required]="true" />
                    <small class="text-red-500"
                        *ngIf="editUserForm.get('firstName')?.touched && editUserForm.get('firstName')?.hasError('required')">
                        First Name is required.
                    </small>
                </section>
                <section class="flex flex-col gap-2">
                    <label for="lastName">Last Name
                        <span style="color: red;">*</span>
                    </label>
                    <input pInputText formControlName="lastName" [required]="true" />
                    <small class="text-red-500"
                        *ngIf="editUserForm.get('lastName')?.touched && editUserForm.get('lastName')?.hasError('required')">
                        Last Name is required.
                    </small>
                </section>


                <section class="flex flex-col gap-2">
                    <label for="email">Email
                        <span style="color: red;">*</span>
                    </label>
                    <input pInputText formControlName="email" [required]="true" />
                    <small class="text-red-500"
                        *ngIf="editUserForm.get('email')?.touched && (editUserForm.get('email')?.hasError('email') || editUserForm.get('email')?.hasError('required'))">
                        Please enter a valid email.
                    </small>
                </section>


                <section class="flex flex-col gap-2">
                    <label for="mobileNumber">Mobile Number</label>
                    <p-inputGroup>
                        <p-inputGroupAddon>+91</p-inputGroupAddon>
                        <input type="tel" pInputText placeholder="" formControlName="mobile" maxlength="10" [required]="true"/>
                    </p-inputGroup>

                </section>


                <section class="flex flex-col gap-2">
                    <label for="gender">Gender
                    </label>
                    <p-dropdown styleClass="!w-full" formControlName="gender" [options]="genderOptions" />
                </section>

                <section class="flex flex-col gap-2">
                    <label for="dob">Date Of Birth
                    </label>
                    <p-calendar formControlName="dob" styleClass="!w-full" [(ngModel)]="date" [iconDisplay]="'input'"
                        [showIcon]="true" inputId="icondisplay" />
                </section>


                <section class="flex flex-col gap-2">
                    <label for="roles">User Role
                    </label>
                    <p-multiSelect  styleClass="!w-full" formControlName="roles" optionValue="value" optionLabel="name"
                    [options]="roleOptions" />
                </section>
                <section class="flex flex-col gap-2">
                    <label for="gender">Organization
                    </label>
                    <p-dropdown styleClass="!w-full" formControlName="organization"  optionLabel="name" [options]="organizationOptions" />
                </section>
                <section class="flex flex-col gap-2">
                    <label for="gender">GSTIN Number
                        <span style="color: red;">*</span>
                    </label>
                    <input pInputText formControlName="gstInNumber" [maxlength]="15" [required]="true" />
                    <small *ngIf="checkErrorMessage(editUserForm, 'gstInNumber', isSubmitted())" class="text-red-500 text-sm mt-1">
                        GST Number is required</small>
                </section>
                <section class="flex flex-col gap-2">
                    <label>Organization Name</label>
                    <input pInputText formControlName="orgName" [autocomplete]="true" [required]="true" />
                  <div *ngIf="checkErrorMessage(editUserForm, 'orgName', isSubmitted())" class="text-red-500 text-sm mt-1">
                    Organization Name is required</div>
                  </section>
            </section>
            <div class="card flex justify-end mt-6">
                <p-button label="Submit" (onClick)="updateUserDetails()" />
            </div>
        </form>
    </div>
</div>
